var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRetryRedo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1C1C1C",
    fillRule: "evenodd",
    d: "M11.225 16.367a.4.4 0 1 1 0 .8h-1.21c-3.918 0-7.097-3.125-7.097-6.984S6.098 3.2 10.016 3.2h.414c.022 0 .043.002.064.005 3.527.132 6.398 2.796 6.782 6.2l.905-1.193a.495.495 0 0 1 .788.599l-1.595 2.1a.495.495 0 0 1-.693.095L14.58 9.41a.495.495 0 1 1 .598-.788l1.316.999c-.29-3.15-2.986-5.622-6.272-5.622h-.206c-3.48 0-6.298 2.77-6.298 6.184s2.818 6.184 6.298 6.184h1.209Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetryRedo);
export default __webpack_public_path__ + "static/media/retry-redo.d16f3f8e584e2de7403cf6881c21380a.svg";
export { ForwardRef as ReactComponent };